export default function _curry1(fn) {
  	return (a) => fn.call(this, a);
}


// WEBPACK FOOTER //
// ./src/common/bare-metal/private/curry1.js